"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aiTranslatedComponentInstance = exports.AiTranslatedComponent = void 0;
const app_1 = require("app");
const AiTranslatedTooltip_1 = require("./AiTranslatedTooltip");
class AiTranslatedComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.ai-translated';
        this.tooltipSelector = '.ai-translated__tooltip';
    }
    OnInit() {
        const tooltipElement = this.el[0].querySelector(this.tooltipSelector);
        const tooltipText = app_1.AttrService.data(this.el[0], "ai-hover-text");
        (0, AiTranslatedTooltip_1.RenderAITranslatedTooltip)({ tooltipText }, tooltipElement);
    }
}
exports.AiTranslatedComponent = AiTranslatedComponent;
exports.aiTranslatedComponentInstance = new AiTranslatedComponent();
